import { useSearchParams } from "next/navigation";
import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { filtersEmpty } from "@/app/components/common-filter-builder/flters-helpers/filter-functions";

export const filtersAtom = atom<any>({});
export const backendFiltersAtom = atom<IFilter[]>([] as IFilter[]);
export const isEmptyFilterAtom = atom(true);

export const useCurrentFilters = (filters: IFilter[]) => {
  const [, setFilterKeys] = useAtom(filtersAtom);
  const [, setBackendFilters] = useAtom(backendFiltersAtom);
  const [, setIsFiltersEmpty] = useAtom(isEmptyFilterAtom);
  const query = useSearchParams();
  useEffect(() => {
    const queryKeys = filters.map((filter) => filter.configurations.key);
    const uniqQueryKeys = [...new Set(queryKeys)];
    const filterState = uniqQueryKeys?.reduce(
      (acc, key) => ({
        ...acc,
        [key]: (query?.get(key) as string)?.split(",") ?? [],
      }),
      {}
    );
    setFilterKeys(filterState);
    setBackendFilters(filters);
    setIsFiltersEmpty(filtersEmpty(filterState));
    return () => {
      // setFilterKeys(filterState);
      setBackendFilters([]);
      // setIsFiltersEmpty(filtersEmpty(filterState));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, query]);
};
